<script setup lang="ts">
// Vue & Plugins
import { ref, computed, inject, Ref } from 'vue'
import { refDebounced  } from '@vueuse/core'

// Composables
import { useShiftReasonQueryInfinite } from '../composables/useShiftReasonQueryInfinite'

// Models
import { Site } from '../../sites/models/site'
import { ShiftReason } from '../models/shiftReason'

// Stores
import { currentSiteKey } from '../../common/injection'

// Data
const props = defineProps<{
  modelValue: ShiftReason | ShiftReason[] | null
}>()

const emit = defineEmits<{
  'update:modelValue': [value?: ShiftReason | ShiftReason[] | null]
}>()

// TODO: Site can be null here so we need to implement a better guard.
//  Ideally we can pass the site as a prop rather than tying the component to assumptions about global state.
const site = inject(currentSiteKey) as Ref<Site>

const nameInput = ref('')
const name = refDebounced(nameInput, 500)

const {
  data,
  isLoading,
} = useShiftReasonQueryInfinite(() => site.value.id, name)

const options = computed<ShiftReason[]>(() => data?.value?.pages.reduce((acc, curr) => { return acc.concat(curr.shiftReasons) }, [] as ShiftReason[]) ?? [])

const value = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})
</script>

<template>
  <Select
    v-model="value"
    :options="options"
    :loading="isLoading"
    option-label="name"
    placeholder="Select Reason"
    class="w-full md:w-96 h-fit"
    show-clear
  />
</template>
